export default {
    "created": "{subject} wurde erstellt",
    "updated": "{subject} wurde aktualisiert",
    "deleted": "{subject} wurde gelöscht",

    "createdMail": 'An <strong>{subject}</strong> soll die E-Mail "{email}" gesendet werden',
    "updatedMail": "Daten der Mail an <strong>{subject}</strong> wurden geändert",
    "updatedMailStatus": "Status der Mail an <strong>{subject}</strong> wurde geändert",
    "failedMail": 'Die E-Mail "{email}" an <strong>{subject}</strong> konnte nicht gesendet werden',

    "createdEducationalConcept": 'Neues Bildungskonzept erstellt',
    "createdEducationalConceptGoal": 'Neues Bildungsziel erstellt',
    "updatedEducationalConcept": 'Bildungskonzept geändert',
    "updatedEducationalConceptGoal": 'Bildungsziel geändert',
    "deletedEducationalConcept": 'Bildungskonzept gelöscht',
    "deletedEducationalConceptGoal": 'Bildungsziel gelöscht',

    "createdStatusNotification": "Statusbenachrichtigung wurde erstellt",
    "updatedStatusNotification": "Statusbenachrichtigung wurde aktualisiert",
    "deletedStatusNotification": "Statusbenachrichtigung wurde gelöscht",

    'createdLocationProject': "Praxisprojekt wurde erstellt",
    'updatedLocationProject': "Praxisprojekt wurde geändert",
    'deletedLocationProject': "Praxisprojekt wurde gelöscht",

    'createdExecutedProgram': "Programmnachweis-Daten im <strong>Formular {formProcess}</strong> wurden erstellt",
    'updatedExecutedProgram': "Programmnachweis-Daten im <strong>Formular {formProcess}</strong> wurden geändert",
    'deletedExecutedProgram': "Programmnachweis-Daten im <strong>Formular {formProcess}</strong> wurden gelöscht",

    "updatedUserSignature": "Signatur wurde erstellt",
    "deletedUserSignature": "Signatur wurde gelöscht",

    "attachedToUser": '"{user}" wurde der Organisation {subject} zugeordnet',
    "attachedToOrganisation": '{subject} wurde der Organisation "{organisation}" zugeordnet',
    "attachedCategory": 'Kategorie "{category}" wurde {subject} zugeordnet',
    "detachedFromUser": '"{user}" wurde aus der Organisation {subject} entfernt',
    "detachedFromOrganisation": '{subject} wurde aus der Organisation "{organisation}" entfernt',
    "detachedCategory": 'Kategorie "{category}" wurde von {subject} entfernt',

    "createdEventPerson": 'Personen-Daten wurden hinzugefügt',
    "updatedEventPerson": 'Personen-Daten wurden geändert',
    "deletedEventPerson": 'Personen-Daten wurden gelöscht',

    "createdEvent": '<strong>Veranstaltung {event}</strong> wurde erstellt',
    "createdProcess": '<strong>Vorgang {process}</strong> wurde erstellt',
    "createdFormProcess": '<strong>Formular {formProcess}</strong> wurde erstellt',
    "createdEventPersonFormProcess": "Dem <strong>Formular {formProcess}</strong> wurde eine Person hinzugefügt",
    "createdDocumentFormProcess": 'Dem <strong>Formular {formProcess}</strong> wurde ein Dokument hinzugefügt',

    "updatedEvent": 'Daten der <strong>Veranstaltung {event}</strong> wurden geändert',
    "updatedProcess": 'Daten des <strong>Vorgangs {process}</strong> wurden geändert',
    "updatedFormProcess": 'Daten des <strong>Formulars {formProcess}</strong> wurden geändert',
    "updatedFormProcessStatus": 'Status des <strong>Formulars {formProcess}</strong> wurde geändert',
    "updatedProcessStatus": 'Status des <strong>Vorgangs {process}</strong> wurde geändert',

    "deletedEvent": 'Die <strong>Veranstaltung {event}</strong> wurde gelöscht',
    "deletedProcess": 'Der <strong>Vorgang {process}</strong> wurde gelöscht',
    "deletedFormProcess": 'Das <strong>Formular {formProcess}</strong> wurde gelöscht',
    "deletedEventPersonFormProcess": 'Vom <strong>Formular {formProcess}</strong> wurde eine Person entfernt',
    "deletedDocumentFormProcess": 'Vom <strong>Formular {formProcess}</strong> wurde ein Dokument entfernt',

    "updatedSignature": 'Das <strong>Formular {formProcess}</strong> wurde unterschrieben',

    "updatedSlNumber": 'SL-Nummer gesetzt: <strong>{slNumber}</strong>',

    "signedTransferAgreementManual": 'Der unterschriebene Weitergabevertrag ist beim Verband eingegangen',
    "signedTransferAgreementUpload": 'Der unterschriebene Weitergabevertrag wurde hochgeladen',
    "signedTransferAgreementDigital": 'Der Weitergabevertrag wurde digital unterschrieben',
    "deletedSignedTransferAgreement": 'Der unterschriebene Weitergabevertrag wurde gelöscht',

    "syncedDocuments": 'Die <strong>Vorgangsdokumente</strong> des Vorgangs wurden geändert (hinzugefügt: {attached}, entfernt: {detached})',
}